import React from "react";
import { FaAward } from "react-icons/fa";
import { VscFolderLibrary } from "react-icons/vsc";
import ME from "../../assets/me.jpg";
import "./intro.css";

const Intro = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About Me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="me" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>3+ years</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>40+ Completed Projects</small>
            </article>
          </div>
          <p>
            I am a Software Engineer with over three years of experience in
            full-stack development, specializing in frontend technologies like
            React and Next.js.
            <br /> I hold a Master&apos;s degree in Information Systems Security
            and a Bachelor&apos;s degree in Software Engineering, which have
            equipped me with a strong foundation in both the technical and
            security aspects of software development.
            <br />
            Throughout my career, I have contributed to a range of projects,
            from developing complex fleet management systems to creating
            professional email management applications.
            <br />
            My goal is to leverage my skills to build high-quality, scalable web
            applications that enhance user experience.
            <br />
            <br />I am looking to join a collaborative team within a company
            that values hard work and genuinely cares about the people who
            contribute to its success. I believe in the importance of a
            supportive work environment where employees are valued for their
            contributions, not just seen as numbers. I&apos;m passionate about
            coding, always eager to learn new technologies, and committed to
            delivering reliable, efficient solutions while growing alongside a
            team that shares these values.
          </p>
          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default Intro;
